import {
    FetchAdsListPayload,
    FetchAdsListResponse,
    AdListCard,
    FetchAdCardSettingsResponse,
} from './adsList.types';
import formatDateString from '../../../helpers/formatDate';
import { updatePaginationButtons } from '../pagination/pagination';
import axios from 'axios';
import saveOrRemoveFavourite from '../../../helpers/favourites';
import { IsFavourited } from '../../../helpers/isFavourite';
import copyToClipboard from '../../../helpers/copyToClipboard';
import addToCalendar from '../../../helpers/addToCalendar';
import IsUserLoggedIn from '../../../helpers/isUserLoggedIn';

const adsList: HTMLDivElement = document.querySelector('.adsComponent-list');

if (adsList) {
    const adsGrid = adsList.querySelector('.adsComponent-list__grid') as HTMLDivElement;
    const adsFilters = adsList.querySelector('.adsComponent-list__search') as HTMLDivElement;
    const adsListSearchInput = adsList.querySelector('.adsComponent-list__search-input') as HTMLInputElement;
    const adTabs: NodeListOf<HTMLButtonElement> = adsList.querySelectorAll('.adsComponent-list__tab');
    const adTabsComponent = adsList.querySelector('.adsComponent-list__tabs') as HTMLDivElement;
    const nextPageButton = adsList.querySelector('.pagination__page-next') as HTMLButtonElement;
    const prevPageButton = adsList.querySelector('.pagination__page-prev') as HTMLButtonElement;
    const paginationDropdown = adsList.querySelector('.pagination__dropdown') as HTMLSelectElement;
    const paginationLast = adsList.querySelector('.pagination__page-last') as HTMLSelectElement;
    const paginationFirst = adsList.querySelector('.pagination__page-first') as HTMLSelectElement;
    const pagination = adsList.querySelector('.pagination') as HTMLDivElement;
    const currentCulture: string = document.documentElement.getAttribute('culture');
    const favouritedIds: number[] = JSON.parse(adsGrid.getAttribute('data-ids'));

    let activeTab: number = 0;

    let adCards: AdListCard[] = [];
    let keyword: string = '';
    let adType: number = 1;
    let pageNumber: number = 1;
    let pageSize: number = +paginationDropdown.value;
    let totalPages: number = 0;
    let totalCount: number = 0;
    let hasNextPage: boolean = false;
    let hasPreviousPage: boolean = false;
    let buttonsToShow: number = 3;
    let isLoading: boolean = false;
    let clickedNumber = null;

    // Functions
    const resetTabs = () => {
        adTabs.forEach((tab) => tab.classList.remove('adsComponent-list__tab--active'));
    };

    const fetchads = async (page = null) => {
        clickedNumber = page;
        pagination.classList.add('hidden');

        if (clickedNumber) {
            pageNumber = page;
        }

        const payload: FetchAdsListPayload = {
            keyword,
            adType,
            pageNumber,
            pageSize,
            currentCulture,
        };

        isLoading = true;

        disableInputs();

        try {
            let response = await axios.post<FetchAdsListResponse>('/api/ads', payload);
            console.log(response);
            
            if(response.headers.loginurl)
                {
                    document.location = response.headers.loginurl;
                }
            adCards = response.data.items;
            if (adCards.length > 0) {
                pagination.classList.remove('hidden');
            }
            totalPages = response.data.totalPages;
            totalCount = response.data.totalCount;
            hasNextPage = response.data.hasNextPage;
            hasPreviousPage = response.data.hasPreviousPage;
            
        } catch (error) {
            console.error(error);
            enableInputs();
        } finally {
            updatePaginationButtons(
                totalPages,
                hasPreviousPage,
                hasNextPage,
                pageNumber,
                pageSize,
                totalCount,
                buttonsToShow,
                adCards,
                fetchads
            );
            isLoading = false;
            updateCards();
            enableInputs();
        }
    };

    const updateCards = () => {
        adsGrid.innerHTML = '';

        adCards.forEach((card: AdListCard) => {
            const cardElement = document.createElement('a');

            cardElement.setAttribute('href', card.link);
            cardElement.className = 'adsComponent-card flex fade-in';

            var _class = '';
            if (IsFavourited(card.id, favouritedIds)) {
                _class = 'active';
            }

            cardElement.innerHTML = `
        <div class="adsComponent-card__image-container">
          <img src="${card.image}" alt="" class="adsComponent-card__image">
        </div>
        <div class="adsComponent-card__content flex flex--column">
          <div class="adsComponent-card__buttons flex flex--align-center flex--justify-end">
          ${
              IsUserLoggedIn()
                  ? `<button class="button button--favourite-small favouriteButton adsComponent-card__button flex flex--justify-center flex--align-center ${_class}" data-type="ad" data-id="${card.id}">
                    </button>`
                  : ''
          }
          
          <button class="button  button--round-small shareButton adsComponent-card__button adsComponent-card__button-share  flex flex--justify-center flex--align-center">
            <img src="/assets/img/img/share-icon.svg" alt="share icon" class="button__image">
          </button>

          </div>
            <h3 class="adsComponent-card__title">${card.title}</h3>
            <h6 class="events-card__column-text">${card.brief}</h6>
          </div>
        </div>
        `;

            adsGrid.appendChild(cardElement);
        });
        addCardListeners();
    };

    const disableInputs = () => {
        pagination.classList.add('disabled');
        adTabsComponent.classList.add('disabled');
        adsFilters.classList.add('disabled');
    };

    const enableInputs = () => {
        pagination.classList.remove('disabled');
        adTabsComponent.classList.remove('disabled');
        adsFilters.classList.remove('disabled');
    };

    // Listeners
    adTabs.forEach((tab, index: number) => {
        tab.addEventListener('click', () => {
            activeTab = index;
            resetTabs();
            adTabs[activeTab].classList.add('adsComponent-list__tab--active');
            pageNumber = 1;
            adType = index+1;

            fetchads();
        });
    });

    paginationDropdown.addEventListener('change', () => {
        pageSize = +paginationDropdown.value;
        pageNumber = 1;
        fetchads();
    });

    nextPageButton.addEventListener('click', () => {
        pageNumber++;

        fetchads();
    });

    prevPageButton.addEventListener('click', () => {
        pageNumber--;

        fetchads();
    });

    paginationFirst.addEventListener('click', () => {
        pageNumber = 1;
        fetchads();
    });

    paginationLast.addEventListener('click', () => {
        pageNumber = totalPages;
        fetchads();
    });

    let timeout = null;
    adsListSearchInput.addEventListener('input', (e) => {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            keyword = adsListSearchInput.value.trim();
            pageNumber = 1;
            fetchads();
        }, 1000);
    });

    // eventDateFrom.addEventListener('change', () => {
    //     dateFrom = eventDateFrom.value;
    //     fetchads();
    // });

    // eventDateTo.addEventListener('change', () => {
    //     dateTo = eventDateTo.value;
    //     fetchads();
    // });


    const initializeadsList = async () => {
        await fetchads();
    };

    // Call the initialize function
    initializeadsList();

    const addCardListeners = () => {
        const serviceListCards: NodeListOf<HTMLAnchorElement> = adsList.querySelectorAll('.adsComponent-card');

        if (serviceListCards.length > 0) {
            const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.adsComponent-card__button');

            serviceListCards.forEach((card) => {
                card.addEventListener('click', (e) => {
                    const target = e.target as HTMLElement;

                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });

            cardButtons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    console.log('small button clicked - adsComponent list');
                    if (button.classList.contains('favouriteButton')) {
                        const t = button.getAttribute('data-type');
                        var id = Number(button.getAttribute('data-id'));
                        saveOrRemoveFavourite(t, id, button);
                    } else if (button.classList.contains('shareButton')) {
                        copyToClipboard(button);
                    } else if (button.classList.contains('calButton')) {
                        addToCalendar(button);
                    }
                });
            });
        }
    };
}

const shareButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.shareButton');

if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            copyToClipboard(button);
        });
    });
}
